<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">
            <a-config-provider :locale="currentLocale">
                <a-card>
                    <template #title>
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <span>Usuários</span>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>Listar</a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>

                    <template #extra>
                        <a-button :icon="h(PlusOutlined)" @click="newRegister">
                            Novo Registro
                        </a-button>
                    </template>

                    <br /><br />

                    <!-- Busca em todas as colunas, sem diferenciação de maiúsculas/minúsculas -->
                    <a-input
                        v-model:value="search"
                        style="width: 350px"
                        type="text"
                        placeholder="Buscar (id, nome, e-mail)"
                        @input="applyFilter"
                        allow-clear
                    />

                    <a-table
                        :columns="columns"
                        :data-source="usersFiltered"
                        :row-key="row => row.id"
                        bordered
                    >
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'acao'">
                                <a-button
                                    type="primary"
                                    shape="circle"
                                    @click="update(record)"
                                    class="q-mr-sm"
                                >
                                    <template #icon>
                                        <a-tooltip>
                                            <template #title>Alterar</template>
                                            <FormOutlined />
                                        </a-tooltip>
                                    </template>
                                </a-button>

                                <a-button
                                    type="primary"
                                    danger
                                    shape="circle"
                                    @click="destroy(record)"
                                >
                                    <template #icon>
                                        <a-tooltip>
                                            <template #title>Excluir</template>
                                            <DeleteOutlined />
                                        </a-tooltip>
                                    </template>
                                </a-button>
                            </template>
                        </template>
                    </a-table>
                </a-card>
            </a-config-provider>
        </a-spin>
    </div>
</template>

<script setup>
import { ref, h, onMounted, computed } from 'vue'
import { PlusOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import ptBR from 'ant-design-vue/es/locale/pt_BR'
import { notification } from 'ant-design-vue'
import { openNotification } from '../../../../utils/utilities'

const currentLocale = ref(ptBR)
const spinning = ref(false)

const route = '/api/configurations/users'

const dataSource = ref([])
const usersFiltered = ref([])

const search = ref('')

const columns = ref([
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        sorter: { compare: (a, b) => Number(a.id) - Number(b.id) }
    },
    {
        title: 'Nome',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        sorter: { compare: (a, b) => String(a.name ?? '').localeCompare(String(b.name ?? '')) }
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: 150,
        sorter: { compare: (a, b) => String(a.email ?? '').localeCompare(String(b.email ?? '')) }
    },
    {
        title: 'Ação',
        key: 'acao',
        width: 90
    }
])

const searchableKeys = computed(() =>
    columns.value.filter(c => !!c.dataIndex).map(c => c.dataIndex)
)

function norm (v) {
    return (v ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
}

function applyFilter () {
    const q = norm(search.value)
    if (!q) {
        usersFiltered.value = dataSource.value.slice()
        return
    }
    usersFiltered.value = dataSource.value.filter(row =>
        searchableKeys.value.some(key => norm(row[key]).includes(q))
    )
}

const update = (row) => {
    window.location.href = `users/${row.id}/edit`
}

const newRegister = () => {
    window.location.href = 'users/create'
}

onMounted(async () => {
    await load()
    applyFilter()
})

const load = async () => {
    try {
        spinning.value = true
        const response = await window.axios.get(route)
        dataSource.value = response.data?.data ?? []
        usersFiltered.value = dataSource.value.slice()
    } catch (error) {
        // opcional: notificar erro
    } finally {
        spinning.value = false
    }
}

const destroy = async (row) => {
    try {
        const response = await window.axios.delete(`${route}/${row.id}`)
        openNotification('success', response.data?.message ?? 'Registro excluído.')
        await load()
        applyFilter()
    } catch (error) {
        openNotification('error', error?.response?.data?.message ?? error.message)
    }
}
</script>

<style scoped>
.anticon {
    vertical-align: 2px !important;
}
</style>
